import { ArrowIconLight } from '@/ui';
import LinkButton from '../button/LinkButton';
import { PaginationWrap } from './Pagination.styles';
import { PageRoutes } from '../../../features/app/pages/domain/constants/PageRoutes';

interface IProps {
	pageNumber: number;
	totalPagesNumber: number;
	root?: string;
	queryString?: string;
}

export function Pagination({
	pageNumber,
	totalPagesNumber,
	root = PageRoutes.News,
	queryString = '',
}: IProps) {
	const prevHrefRootPage =
		pageNumber === 2 ? root : `${root}/${pageNumber - 1}`;
	const prevHref = queryString
		? `${prevHrefRootPage}/?${queryString}`
		: prevHrefRootPage;
	const prevDisabled = pageNumber === 1;
	const nextHrefRootPage = `${root}/${pageNumber + 1}`;
	const nextHref = queryString
		? `${nextHrefRootPage}/?${queryString}`
		: nextHrefRootPage;

	const nextDisabled = pageNumber === totalPagesNumber;

	return (
		<PaginationWrap>
			<LinkButton
				as={prevDisabled ? 'span' : 'a'}
				href={prevHref}
				aria-disabled={prevDisabled}
				role="link"
				aria-label="Previous"
				buttonType="secondary"
				icon={<ArrowIconLight style={{ transform: 'rotate(180deg)' }} />}
				iconPosition="left"
				shallow
			>
				Previous
			</LinkButton>

			<LinkButton
				as={nextDisabled ? 'span' : 'a'}
				href={nextHref}
				aria-disabled={nextDisabled}
				role="link"
				buttonType="secondary"
				aria-label="Next"
				icon={<ArrowIconLight />}
				shallow
			>
				Next {pageNumber}/{totalPagesNumber}
			</LinkButton>
		</PaginationWrap>
	);
}
